<template>
  <b-card border-variant="secondary">
    <b-card-title title-tag="h4" class="mb-1">
      User Profile
    </b-card-title>
    <b-card-body class="row">
      <template v-for="(item, idx) in fields">
        <InputField :key="idx" v-bind="item" />
      </template>
    </b-card-body>
  </b-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import InputField from '@/components/InputField';
import ResourceService from '@/services/ResourceService';

const resource = new ResourceService();

export default {
  name: 'UserAccount',
  components: {
    InputField,
  },
  data() {
    return {
      userEmployeeData: {},
    };
  },
  mounted() {
    this.getUserData();
  },
  computed: {
    // TODO: get approver name
    fields() {
      const defaultOptions = {
        readonly: true,
        tagClass: 'col-12 col-sm-6 col-lg-4 mb-2',
        labelClass: 'font-weight-bold mb-0',
        inputClass: 'form-control-plaintext no-outline border-0',
      };
      return [
        {
          label: 'Name',
          value: this.$get(this.userEmployeeData, 'full_name', '-'),
          options: defaultOptions,
        },
        {
          label: 'Username',
          value: this.$get(this.userEmployeeData, 'username', '-'),
          options: defaultOptions,
        },
        {
          label: 'Employee No.',
          value: this.$get(this.userEmployeeData, 'employee_no', '-'),
          options: defaultOptions,
        },
        {
          label: 'Email',
          value: this.$get(this.userEmployeeData, 'email', '-'),
          options: defaultOptions,
        },
        {
          label: 'Department',
          value: this.$get(this.userEmployeeData, 'department', '-'),
          options: defaultOptions,
        },
        {
          label: 'Team',
          value: this.$get(this.userEmployeeData, 'team', '-'),
          options: defaultOptions,
        },
        {
          label: 'Shift Schedule',
          value: this.$get(this.userEmployeeData, 'shift_schedule_str', '-'),
          options: defaultOptions,
        },
      ];
    },
    ...mapGetters(['userData']),
  },
  methods: {
    getUserData() {
      const { id } = this.userData;
      this.startLoadingRequest();
      this.startLoadingPage();
      resource.get(`/user/${id}`)
        .then(({ success, data, message }) => {
          if (!success) {
            this.setNotification({
              show: true,
              variant: 'danger',
              refresh: true,
              message: message || 'An error occurred',
              icon: {
                name: 'exclamation-triangle',
                class: 'text-danger',
              },
            });
          }
          // save user data
          this.userEmployeeData = success ? data : {};
        })
        .catch((response) => {
          const { status, statusText: data } = response;
          const error = { status, data };

          const errorMessage = this.$get(error, 'data', 'An error occurred');
          this.setNotification({
            show: true,
            variant: 'danger',
            message: errorMessage,
            refresh: true,
            icon: {
              name: 'exclamation-triangle',
              class: 'text-danger',
            },
          });
        })
        .then(() => {
          this.stopLoadingRequest();
          this.stopLoadingPage();
        });
    },
    ...mapActions([
      'startLoadingRequest',
      'stopLoadingRequest',
      'startLoadingPage',
      'stopLoadingPage',
      'setNotification',
    ]),
  },
};
</script>
